import { render, staticRenderFns } from "./notification-center-list.vue?vue&type=template&id=7c054be7&scoped=true"
import script from "./notification-center-list.vue?vue&type=script&lang=js"
export * from "./notification-center-list.vue?vue&type=script&lang=js"
import style0 from "./notification-center-list.vue?vue&type=style&index=0&id=7c054be7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c054be7",
  null
  
)

export default component.exports